import getWithToken from './base/get-with-token'

const getCustomersDetailPublic = id => getWithToken(`/customer/${id}/get-name-for-screenshot`)()

export default getCustomersDetailPublic